export const toCpfMask = (document: string | undefined) => {
  if (!document) return '';
  const cpf = document.replace(/[^\d]/g, '');
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};
